import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=0cfd4a84&"
import script from "./signature.vue?vue&type=script&lang=ts&"
export * from "./signature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports